<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary">
  Batch summary
</mat-toolbar>
<mat-card>
<table
mat-table
[dataSource]="dataSource"
matSort matSortActive="jobStatus" matSortDirection="asc">
<ng-container matColumnDef="jobName">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Name</th>
  <td mat-cell *matCellDef="let row">{{ row.jobName }}</td>
</ng-container>
<ng-container matColumnDef="jobStatus">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Status</th>
  <td mat-cell *matCellDef="let row">{{ row.jobStatus }}</td>
</ng-container>
<ng-container matColumnDef="function">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Function</th>
  <td mat-cell *matCellDef="let row">{{ row.function }}</td>
</ng-container>
<ng-container matColumnDef="createdAt">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
  <td mat-cell *matCellDef="let row">{{ row.createdAt | date: "medium":"+0200":"de" }}</td>
</ng-container>
<ng-container matColumnDef="startedAt">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Started At</th>
  <td mat-cell *matCellDef="let row">{{ row.startedAt | date: "medium":"+0200":"de" }}</td>
</ng-container>
<ng-container matColumnDef="stoppedAt">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Stopped At</th>
  <td mat-cell *matCellDef="let row">{{ row.stoppedAt | date: "medium":"+0200":"de" }}</td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

</table>
</mat-card>
